// @ts-nocheck
import { Injectable, inject } from '@angular/core';
import moment from 'moment';
import { Observable, Subject } from 'rxjs';
import { GLOBAL_CONSTANT } from '../../../../../contants/global.const';
import { SEND_SERVICE } from '../../../../../services/send.service';
import { field } from './claim.fields';

@Injectable({
  providedIn: 'root',
})
export class ClaimService {
  public showPopupFeedController = new Subject<Array<any>>();

  readonly sendService = inject(SEND_SERVICE);
  readonly Global = inject(GLOBAL_CONSTANT);

  public getAllMonetaryRate<T>(): Observable<T> {
    const url = this.Global.services.monetaryRate.monetaryRate();
    return this.sendService.get(url, {});
  }

  public getStep<T>(params): Observable<T> {
    const url = this.Global.services.legalRequest.step();
    return this.sendService.get(url, { params });
  }

  public getCorrectionCalculation<T>(params): Observable<T> {
    const url = this.Global.services.monetaryRate.correctionCalculation();
    return this.sendService.get(url, { params });
  }

  public step<T>(body, params): Observable<T> {
    const url = this.Global.services.legalRequest.step();
    return this.sendService.post(url, body, { params });
  }

  public createLegalRequest<T>(body, params): Observable<T> {
    const url = this.Global.services.legalRequest.request();
    return this.sendService.post(url, body, { params });
  }

  public request<T>(params): Observable<T> {
    const url = this.Global.services.legalRequest.request();
    return this.sendService.get(url, { params });
  }

  public editClaim<T>(body, id): Observable<T> {
    const url = this.Global.services.legalRequest.draft();
    return this.sendService.put(url, body, { params: id });
  }

  public getStepDropDown<T>(params): Observable<T> {
    const url = this.Global.services.legalRequest.dropDown();
    return this.sendService.get(url, { params });
  }

  readInputTimeOutDebounce;

  public async correctionCalculation({
    dateReference,
    primaryValue,
    primaryIndexId,
    hasInterest,
    hasPenalty,
    interestDateReference,
    interestPercents,
    penaltyPercents,
  }: any): Promise<any> {
    const startDate = dateReference;
    const endDate = moment().unix();
    const value = parseFloat(primaryValue);
    const indexRateName = primaryIndexId;

    const params = {
      indexRateName,
      value,
      startDate,
      endDate,
      hasInterest,
      hasPenalty,
      interestDateReference,
      interestPercents,
      penaltyPercents,
    };

    return new Promise((resolve, reject) => {
      this.getCorrectionCalculation(params).subscribe(
        (response: any) => resolve(response),
        (err: any) => {
          reject(err);
          console.error(`error`, err);
        }
      );
    });
  }

  public async calcValoresCadastroPedidos(listFieldsEdit: any = null): Promise<any> {
    const _field: any = field.fields;
    return new Promise((resolve) => {
      let primaryValue;
      let primaryIndexId;
      let risk;
      let dateReference;
      let hasInterest;
      let hasPenalty;
      let interestDateReference;
      let interestPercents;
      let penaltyPercents;

      if (listFieldsEdit) {
        primaryValue = listFieldsEdit.primaryValue;
        primaryIndexId = listFieldsEdit.primaryIndexId;
        risk = listFieldsEdit.risk;
        dateReference = listFieldsEdit.dateReference;
        hasInterest = listFieldsEdit.hasInterest;
        hasPenalty = listFieldsEdit.hasPenalty;
        interestDateReference = listFieldsEdit.interestDateReference;
        interestPercents = listFieldsEdit.interestPercents;
        penaltyPercents = listFieldsEdit.penaltyPercents;
      } else {
        risk = _field.find((item) => item.entityKey === 'risk').value;
        dateReference = _field.find((item) => item.entityKey === 'dateReference').value;

        const campos = _field.find((i) => i.type === 'ADDITIONAL_VALUES').fields;
        campos.forEach((grupos) => {
          if (grupos.entityKey === 'hasInterest') hasInterest = grupos.enabled;
          if (grupos.entityKey === 'hasPenalty') hasPenalty = grupos.enabled;

          grupos.fields.forEach((item) => {
            item.forEach((campo) => {
              if (campo.entityKey === 'primaryValue') primaryValue = campo.value;
              if (campo.entityKey === 'primaryIndexId') primaryIndexId = campo.value;
              if (campo.entityKey === 'interestPercents') interestPercents = campo.value || '0';
              if (campo.entityKey === 'interestDateReference') interestDateReference = campo.value;
              if (campo.entityKey === 'penaltyPercents') penaltyPercents = campo.value || '0';
            });
          });
        });
      }

      let totalRisco = 0; // remoto
      if (risk === 'possivel') totalRisco = 50;
      if (risk === 'provavel') totalRisco = 100;

      if (primaryValue && primaryIndexId) {
        clearTimeout(this.readInputTimeOutDebounce);

        this.readInputTimeOutDebounce = setTimeout(async () => {
          const params = {
            dateReference,
            primaryValue,
            primaryIndexId,
            hasInterest,
            hasPenalty,
            interestDateReference,
            interestPercents,
            penaltyPercents,
          };

          this.correctionCalculation(params)
            .then((corrections) => {
              let totalUpdated = 0;

              if (corrections.correctedBalance && corrections.correctedBalance !== 'NaN') {
                totalUpdated += Number(corrections.correctedBalance);
              }
              if (corrections.interestValue && corrections.interestValue !== 'NaN') {
                totalUpdated += Number(corrections.interestValue);
              }
              if (corrections.penaltyValue && corrections.penaltyValue !== 'NaN') {
                totalUpdated += Number(corrections.penaltyValue);
              }

              return resolve({
                valTotalInicial:
                  corrections.balance && corrections.balance !== 'NaN'
                    ? String(corrections.balance)
                    : '0.00',
                valTotalAtualizado: totalUpdated.toFixed(2),
                valTotalRisco: ((totalUpdated * totalRisco) / 100).toFixed(2),
              });
            })
            .catch((error) => {
              return resolve({
                valTotalInicial: '0.00',
                valTotalAtualizado: '0.00',
                valTotalRisco: '0.00',
              });
            });
        }, 300);
      } else {
        return resolve({
          valTotalInicial: '0.00',
          valTotalAtualizado: '0.00',
          valTotalRisco: '0.00',
        });
      }
    });
  }
}
